const fallbackServices = [
    { id: 'fake-1', txt: 'Water pipelines', isFake: true },
    { id: 'fake-2', txt: 'Gas pipelines', isFake: true },
    { id: 'fake-3', txt: 'Warmth pipelines', isFake: true },
    { id: 'fake-4', txt: 'Plant construction', isFake: true },
    { id: 'fake-5', txt: 'Cable constructions', isFake: true },
];

export default fallbackServices;


